import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { GeneratePdf } from '../../components/GeneratePdf';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionTeacherCredentials = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const [credentials, setCredentials] = useState("");
    const [showPassword, setShowPassword] = useState([]);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [teacherNameSort, setTeacherNameSort] = useState(null);
    const [genderSort, setGenderSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["teacher.teacherName", "teacher.email", "teacher.contactNumber", "teacher.gender", "userId"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getCredentials();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getCredentials();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setCredentials(await searchArray("B", `/get-teachers-details?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`, searchKeys, searchValue.trim(), "data"));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(credentials, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(credentials.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > credentials.length) {
            endIndex = credentials.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(credentials.slice(startIndex, endIndex));
    }, [credentials, currPage, itemsPerPage]);

    const getCredentials = async () => {
        try {
            setLoading(true);
            const apiUrlForInstituteList = `/get-teachers-details?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
            const response = await authorizedAxiosSection.get(apiUrlForInstituteList);
            setCredentials(response.data.data);
            // setShowPassword(Array(response.data.data.length).fill(false));
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const togglePasswordVisibility = (index) => {
        setShowPassword(prevState => {
            const updatedShowPassword = [...prevState];
            updatedShowPassword[index] = !updatedShowPassword[index];
            return updatedShowPassword;
        });
    };

    const sendMail = async (email, userId, password) => {
        setLoading(true);
        const data = {
            email: email,
            userId: userId,
            password: password
        };

        const apiUrl = `/send-credential-to-mail`;

        try {
            const response = await authorizedAxiosCommon.post(apiUrl, data);
            setTimeout(() => {
                Swal.fire({ text: response.data.message });
            }, 100);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false); // End loading
        }
    };

    useEffect(() => {
        if (teacherNameSort == true || teacherNameSort == false) {
            setGenderSort(null);
        }
    }, [teacherNameSort])

    useEffect(() => {
        if (genderSort == true || genderSort == false) {
            setTeacherNameSort(null);
        }
    }, [genderSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Teacher Credentials</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-key"></i>Teacher Credentials</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <GeneratePdf id="teacherCredentitals" title={credentials} headerTitle={"Teacher Credentials"} />
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div id="teacherCredentitals">
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Teacher Name
                                                                                <SortIcon sortState={teacherNameSort} setSortState={setTeacherNameSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"teacher.teacherName"} />
                                                                            </th>
                                                                            <th scope="col">Email </th>
                                                                            <th scope="col">Contact Number </th>
                                                                            <th scope="col">
                                                                                Gender
                                                                                <SortIcon sortState={genderSort} setSortState={setGenderSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"teacher.gender"} />
                                                                            </th>
                                                                            <th scope="col">User Id</th>
                                                                            <th scope="col">Password</th>
                                                                            <th scope='col'>Send Mail</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData?.length > 0 ?
                                                                                displayedData?.map((cred, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{cred.teacher.teacherName}</td>
                                                                                            <td>{cred.teacher.email}</td>
                                                                                            <td>{cred.teacher.contactNumber}</td>
                                                                                            <td>{cred.teacher.gender}</td>
                                                                                            <td>{cred.userId}</td>
                                                                                            <td>
                                                                                                {showPassword[index] ? (cred.password) : ('••••••••')}
                                                                                                <button
                                                                                                    className="btn btn-link"
                                                                                                    type="button"
                                                                                                    onClick={() => togglePasswordVisibility(index)}
                                                                                                >
                                                                                                    <i className={`fa ${showPassword[index] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                                                                </button>
                                                                                            </td>
                                                                                            {/* <td>

                                                                                        <div className={`toggle-container ${cred.adminDeActivate ? '' : 'active'}`}  onClick={()=>changeActive(cred.id , cred.adminDeActivate)}>
                                                                                            <div className="toggle-background"></div>
                                                                                            <div className="toggle-switch"></div>
                                                                                        </div>

                                                                                    </td> */}
                                                                                            <td>
                                                                                                <button className="btn btn-outline-info" type="button" onClick={() => sendMail(cred.teacher.email, cred.userId, cred.password)}>
                                                                                                    <i className="fa fa-paper-plane"></i>
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Credentials Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={credentials.length} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionTeacherCredentials;
